// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");

function getBaseName(prim) {
  return $dot$dot.getBaseName(prim);
}

function isTerminal(prim) {
  return $dot$dot.isTerminalPatchPath(prim);
}

function isJumper(prim) {
  return $dot$dot.isJumperPatchPath(prim);
}

function isBus(prim) {
  return $dot$dot.isBusPatchPath(prim);
}

function isFromBus(prim) {
  return $dot$dot.isFromBusPatchPath(prim);
}

function isToBus(prim) {
  return $dot$dot.isToBusPatchPath(prim);
}

exports.getBaseName = getBaseName;
exports.isTerminal = isTerminal;
exports.isJumper = isJumper;
exports.isBus = isBus;
exports.isFromBus = isFromBus;
exports.isToBus = isToBus;
/* .. Not a pure module */
